// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9be21b27","455":"6f4a0ddc"}[chunkId] + ".chunk.js";
};